
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthProvider';
import Home from '@/pages/Home';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';

const AuthenticatedRoute = () => {
  const { user, loading } = useAuth();
  const [isAuthChecking, setIsAuthChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check for active session
    const checkSession = async () => {
      try {
        const { data } = await supabase.auth.getSession();
        console.log("Checking session in AuthenticatedRoute:", data);
        setIsAuthenticated(!!data.session);
        setIsAuthChecking(false);
      } catch (error) {
        console.error("Error checking session:", error);
        setIsAuthenticated(false);
        setIsAuthChecking(false);
      }
    };

    checkSession();
  }, []);

  // Show loading spinner while checking auth state
  if (loading || isAuthChecking) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
        <Loader2 className="h-12 w-12 text-blue-600 animate-spin mb-4" />
        <p className="text-gray-600 text-sm">Verifying credentials...</p>
      </div>
    );
  }

  // If authenticated or session exists, show Home page
  if (user || isAuthenticated) {
    return <Home />;
  }

  // If not authenticated, redirect to landing page instead of signin
  return <Navigate to="/" replace />;
};

export default AuthenticatedRoute;
